import { memo } from "react";
import PropTypes from "prop-types";
import "./BookingSearch.scss";
import SearchEngineContainer from "app/pages/PrePackage/SearchEngineContainer";
import { FormattedMessage } from "react-intl";
import AlertMessage from "app/components/ui/AlertMessage/AlertMessage";
import Loader from "app/pages/.shared/Loader";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import classNames from "classnames";

const BookingSearch = ({ alertMessage, displaySearchEngine }) => {
	const bookingSearchClassName = classNames("booking-search", {
		"booking-search--with-alert": Boolean(alertMessage),
	});

	return (
		<div className={bookingSearchClassName}>
			{alertMessage && <AlertMessage message={alertMessage} />}
			<Typography variant={TYPOGRAPHY_VARIANTS.XL2} isBold className="booking-search__title">
				<FormattedMessage id="search.booking.title" />
			</Typography>
			{/* displaySearchEngine permet d'afficher le moteur de recherche que si on a l'info ficheProduit.isChildAgeRequired
			ce qui permet d'afficher les champs dates de naissances ou pas en fonction
			*/}
			{displaySearchEngine ? (
				<div className="booking-search__content">
					<SearchEngineContainer />
				</div>
			) : (
				<div className="booking-search__content" style={{ textAlign: "center" }}>
					<Loader />
				</div>
			)}
		</div>
	);
};

BookingSearch.propTypes = {
	displaySearchEngine: PropTypes.bool,
	alertMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default memo(BookingSearch);
